/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { DEVICE } from "src/app/globalStyles";

import { LDFooterWrapper } from "./Layout/HeadFoot";

export const LDFooter = () => (
  <LDFooterWrapper>
    <FooterText>VIENNA HYPERTEXT INC © 2023</FooterText>
  </LDFooterWrapper>
);

const FooterText = styled.div`
  color: #cccccc;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;

  @media (max-width: ${DEVICE.small}) {
    font-size: 11px;
  }
`;
